import { compact, isNil, map, sortBy, uniqBy } from 'lodash'

const fieldToOptions = (elements, field) => {
  const options = map(
    compact(map(elements, field)),
    fieldOption => ({ value: fieldOption, label: fieldOption })
  )

  return sortBy(uniqBy(options, 'value'), 'label')
}

const objectToOptions = (elements, value, label = value, assetName = null) => {
  const objects = compact(isNil(assetName) ? elements : map(elements, assetName))
  const options = compact(map(objects, (asset) => {
    if (isNil(asset[label])) { return null }

    return { value: asset[value], label: asset[label] }
  }))

  return sortBy(uniqBy(options, 'value'), 'label')
}

const arrayToOptions = (array, labelFunction = (label) => label) => {
  const uniqArray = uniqBy(compact(array))
  const options = map(uniqArray, element => ({ value: element, label: labelFunction(element) }))

  return sortBy(options, 'label')
}

export { arrayToOptions, fieldToOptions, objectToOptions }
